import {lazy} from 'react';
export const Index = lazy(() => import("./components/Index"));
export const About = lazy(() => import("./components/About"));
export const Contact = lazy(() => import("./components/Contact"));
export const Faq = lazy(() => import("./components/Faq"));
export const RemanufacturedToner = lazy(() => import("./components/RemanufacturedToner"));
export const TonerRefilling = lazy(() => import("./components/TonerRefilling"));